<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 207.912"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M44.353 82.356c3.314,0.726 6.648,0.968 10.001,0.728 -0.354,23.073 0.37,56.098 -0.77,93.626 -5.203,-30.504 -8.28,-61.956 -9.231,-94.354z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M79.315 29.597c-0.525,7.032 -2.66,17.965 -7.716,26.367 -0.853,1.418 -1.79,2.764 -2.816,4.007 -5.297,-4.496 -11.041,-7.02 -17.232,-7.57 4.521,-10.315 5.561,-22.016 3.123,-35.102 6.359,-0.168 12.932,-1.219 19.721,-3.152 3.563,4.35 5.344,9.754 4.92,15.45z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M54.674 17.299c2.438,13.086 1.398,24.787 -3.123,35.102 -3.342,-0.297 -6.815,-0.019 -10.418,0.834 -2.761,-9.976 -3.028,-22.351 -0.801,-37.125 4.652,0.922 9.433,1.318 14.342,1.189z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M40.332 16.11c-2.227,14.774 -1.96,27.149 0.801,37.125 -3.464,0.82 -7.048,2.173 -10.753,4.056 -1.802,-2.178 -3.23,-4.524 -4.33,-6.878 -3.465,-7.408 -6.255,-11.531 -6.934,-16.513 -1.166,-8.562 2.362,-16.272 8.637,-21.697 4.084,1.752 8.277,3.054 12.579,3.907z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M74.395 14.147c-16.773,4.776 -32.47,4.038 -46.621,-1.962 5.707,-4.925 13.683,-7.961 22.466,-8.035 10.751,-0.09 19.186,3.93 24.155,9.997z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M51.551 52.401c6.191,0.55 11.935,3.074 17.232,7.57 -4.685,5.677 -11.237,9.204 -20.254,7.636 -8.26,-1.436 -14.134,-5.461 -18.149,-10.316 3.705,-1.883 7.289,-3.236 10.753,-4.056 3.603,-0.853 7.076,-1.131 10.418,-0.834z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M71.599 55.965c-4.873,40.449 -1.227,91.69 -11.579,142.042 -12.01,25.261 -16.912,-30.472 -25.469,-83.595 -5.874,-36.46 -4.571,-47.49 -4.171,-57.121m19.86 -53.141c-18.459,0.155 -33.351,13.398 -31.124,29.75 0.679,4.982 3.469,9.105 6.934,16.513 1.1,2.354 2.529,4.699 4.33,6.878 4.016,4.855 9.889,8.88 18.149,10.316 10.991,1.911 18.32,-3.748 23.07,-11.642 5.055,-8.402 7.191,-19.336 7.716,-26.368 1.017,-13.64 -10.615,-25.602 -29.075,-25.447z"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
